// @flow
import type { State } from '../types';

export const parametersSelector = (state: State) => state.parameters.parameters;
